import { render, staticRenderFns } from "./OrderCalendar.vue?vue&type=template&id=23270216"
import script from "./OrderCalendar.vue?vue&type=script&lang=js"
export * from "./OrderCalendar.vue?vue&type=script&lang=js"
import style0 from "./OrderCalendar.vue?vue&type=style&index=0&id=23270216&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports